module.exports = __webpack_public_path__ + "img/Katarina_home_04.b4fe2a54.jpg";